import React, { useCallback, useEffect, useState } from "react";
import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import SortedTable from "./table";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, getAllUsersThunk } from "redux/slices/allUsersSlice";
import LoadingComponent from "components/LoadingComponent";
import { NewUser } from "types/Authentication";
import WithAuthWrapper from "withWrapper/withAuthWrapper";

const header = [
  { id: "fullName", name: "" },
  { id: "fullName", name: "Full Name" },
  { id: "email", name: "Stamps Collected" },
  { id: "source", name: "Last Stamps Collected" },
  { id: "action", name: "Action" }
];
const AllUsersPage: React.FC = () => {
  const accessToken = localStorage.getItem("stmpz-token") || "";
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const dispatch = useDispatch();
  const allUsers = useSelector(getAllUsers);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [, setIsEdit] = useState<boolean>(false);
  const [, setSelectedUser] = useState<NewUser>();

  const getAllUsersTableList = useCallback(
    (businessId: string, page: number, username?: string) => {
      if (!!accessToken)
        dispatch(
          getAllUsersThunk({
            accessToken,
            page: page,
            name: username || "",
            businessId: businessId
          })
        );
    },
    [accessToken, dispatch]
  );

  useEffect(() => {
    if (!!accessToken && !!allUsers && !allUsers.customers) {
      getAllUsersTableList(businessId, 1);
    }
  }, [accessToken, allUsers, businessId, getAllUsersTableList]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!!allUsers && allUsers.customers ? (
        <SortedTable
          header={header}
          rows={allUsers}
          onPageChanged={(newPage: number) =>
            getAllUsersTableList(businessId, newPage + 1)
          }
          handleUserSearch={(username: string) =>
            getAllUsersTableList(businessId, 1, username)
          }
          onReload={(currentPage: number) =>
            getAllUsersTableList(businessId, currentPage + 1)
          }
          addNewOrEditUser={(isEditAction: boolean, selectedUser?: NewUser) => {
            setSelectedUser(selectedUser);
            setIsEdit(isEditAction);
            setModalOpen(!isModalOpen);
          }}
        />
      ) : (
        <LoadingComponent />
      )}
    </DashboardLayout>
  );
};

export default WithAuthWrapper(AllUsersPage);
